import { Tooltip } from "@mui/material";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton.tsx";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon.tsx";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon.tsx";
import CollapseAllIcon from "@entrilia/shared/icons/CollapseAllIcon.tsx";
import ExpandAllIcon from "@entrilia/shared/icons/ExpandAllIcon.tsx";

export interface PivotExpansionControl {
  expanded: boolean;
  onToggle: () => void;
}

interface Props extends PivotExpansionControl {
  label: string;
  all?: boolean;
}

const PivotExpansionButton = ({ expanded, onToggle, label, all }: Props) => {
  return (
    <Tooltip title={label} arrow enterDelay={500} enterNextDelay={500}>
      <ExpandCollapseButton
        aria-label={label}
        aria-expanded={expanded}
        expanded={expanded}
        onToggle={onToggle}
        ExpandIcon={all ? ExpandAllIcon : ExpandIcon}
        CollapseIcon={all ? CollapseAllIcon : CollapseIcon}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.stopPropagation();
          }
        }}
      />
    </Tooltip>
  );
};

export default PivotExpansionButton;
